import { render, staticRenderFns } from "./investors.vue?vue&type=template&id=26a001bc&scoped=true&"
import script from "./investors.vue?vue&type=script&lang=js&"
export * from "./investors.vue?vue&type=script&lang=js&"
import style0 from "./investors.vue?vue&type=style&index=0&id=26a001bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a001bc",
  null
  
)

export default component.exports